import React, {Component} from "react";
import "./AvvisiItem.css";
import UserAvatar from "../../../Controls/UserAvatar.mjs";
import DateLabel from "../../../Controls/DateLabel.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";
import AvvisiPreviewRecipients from "./AvvisiPreviewRecipients.mjs";
import ReadIcon from "../../../media/images/ReadIcon.mjs";

const prefix = "AvvisiItem";

const AvvisiItem = class extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}
	render() {
		const m = this.props.notice;
		return (
			<div
				className={prefix} id={m.id}
				onClick={ this.props.select }
			>
				<div className={"usericon"}>
					<UserAvatar player={ m.player } />
				</div>
				<div className={"info"}>
					<div className={"date"}>
						<DateLabel value={m.time}/>
					</div>
					<div
						className={"people to"}
						onClick={ e=> {
							e.preventDefault();
							e.stopPropagation();
							this.setState({details: m.to});
						} }
					>
						<em>
							<TextLabel value={"Recipients"}/>:
						</em>
						<b>
							{m.to.length}
							<ReadIcon />
						</b>
					</div>
					<div className={"subject"}>
						{m.subject}
					</div>
				</div>
				{ this.state.details && (
					<AvvisiPreviewRecipients
						list={this.state.details}
						onClose={()=>{ this.setState({details: false}) }}
					/>
				)}
			</div>
		)
	}
}

export default AvvisiItem;